import gsap from 'gsap';
import React, { useLayoutEffect, useRef } from 'react'
import { Link } from 'react-router-dom'
import { motion } from 'framer-motion'

const Header = () => {
  const headerH = useRef();

  useLayoutEffect(() => {

    const cursorDiv = document.getElementsByClassName('cursor')[0]
    window.addEventListener("mousemove", (dets) => {
      gsap.to(cursorDiv, {
        left: dets.x - 10,
        top: dets.y - 10
      })
    })

    document.querySelectorAll('.heading').forEach((item) => {
      item.addEventListener("mouseenter", () => {
        cursorDiv?.classList.add("grow")
      })
      item.addEventListener("mouseleave", (e) => {
        cursorDiv?.classList.remove("grow")
      })
    })

    document.querySelectorAll('.spanDetail').forEach((item) => {
      item.addEventListener("mouseenter", () => {
        cursorDiv?.classList.add("grow")
      })
      item.addEventListener("mouseleave", (e) => {
        cursorDiv?.classList.remove("grow")
      })
    })

  }, [])

  return (
    <>
      <header ref={headerH}>
        <nav>
          <div className="navLogo">
            <Link to={"/"}>
              <motion.img src="/logo.png" alt="" layoutId='logo-1'
              transition={{ease: [0.83, 0, 0.17, 1] , duration: 1.5}}
              />
            </Link>
          </div>
        </nav>
      </header>
    </>
  )
}

export default Header